import axios from "@/plugins/axios";

export default {
  getImage(id) {
    return axios.get(`/client_images/${id}`);
  },
  getImageList(client_id) {
    return axios.get(`/clients/${client_id}/images`);
  },

  addImage(client_id, { description, key }) {
    return axios.post(`/clients/${client_id}/images`, { description, key });
  },
  updateImage(id, { description, description_cache, dependent_id }) {
    // Note: CANNOT replace actual image
    return axios.post(`/client_images/${id}`, {
      description,
      description_cache,
      client_id: dependent_id,
    });
  },
  saveDefaultImages(imageList) {
    return axios.post("/client_image_defaults", {
      images: imageList,
    });
  },
  deleteImage(id) {
    return axios.delete(`/client_images/${id}`);
  },
  deleteImageList(idList) {
    return axios.delete("/client_images", {
      data: { image_list: idList },
    });
  },
};
